import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { Form, FormElement, Field } from "@progress/kendo-react-form";
import { FormInput } from "../../../components/sys-form/FormComponents";
import { requiredValidator } from "../../../components/sys-form/FormValidators";
import DavetliEtkinlikService from "../../../services/srv-davetli/DavetliEtkinlikService";

export const GuestEventForm = (props) => {
  const { t } = useTranslation();
  const isUpdate = !!props.isUpdate;

  const onSubmit = (dataItem) => {
    const { isValid, values } = dataItem;
    if (!isValid) return;

    if (isUpdate) {
      DavetliEtkinlikService.update({
        DAVETLI_ETKINLIK_TANIM_ID: props.event.davetlI_ETKINLIK_TANIM_ID,
        ETKINLIK_ADI: values.ETKINLIK_ADI,
      }).then((res) => {
        if (!res) return;
        props.toggleDialog();
        props.setIsAdded(true);
      });
    } else {
      DavetliEtkinlikService.add({
        ETKINLIK_ADI: values.ETKINLIK_ADI,
      }).then((res) => {
        if (!res) return;
        props.toggleDialog();
        props.setIsAdded(true);
      });
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Form
        onSubmitClick={onSubmit}
        initialValues={{
          ETKINLIK_ADI: props.event?.etkinliK_ADI || "",
        }}
        render={(formRenderProps) => (
          <div style={{ alignSelf: "center", width: "80%" }}>
            <FormElement>
              <Field
                name="ETKINLIK_ADI"
                id="ETKINLIK_ADI"
                label={t("event_name")}
                component={FormInput}
                validator={(value) => requiredValidator(value, t)}
              />
              <div className="k-form-buttons">
                <Button disabled={!formRenderProps.allowSubmit}>
                  {t("save")}
                </Button>
              </div>
            </FormElement>
          </div>
        )}
      />
    </div>
  );
};
